import { IS_ACC_TOGGLE, LEAD_STATUS, LEAD_TYPE, POLICY_HOLDER, QUOTATION_SHARE_TYPE } from "@src/config/id/constant";

/**
 * Docs step "save before submit" helpers (Continue Application flow).
 * Unsubmitted Docs values are stored on the lead while it stays at Quotation Shared (status 1 / sub status 1).
 */

// customer values that only the Docs step fills
export const DOCS_VALUE_KEYS = ['name', 'email', 'mobile', 'ktp_id', 'npwp_no', 'per_house_no', 'cur_house_no'];

const hasValue = (value: any) => value !== undefined && value !== null && value !== '';

export const hasDocsData = (data: any): boolean => DOCS_VALUE_KEYS.some((key) => hasValue(data?.[key]));

/** lead still at Quotation Shared (1/1) -> Docs values may be saved */
export const isQuotationSharedLead = (data: any): boolean =>
    +data?.status_id === LEAD_STATUS.quotation_shared.status_id &&
    +data?.sub_status_id === LEAD_STATUS.quotation_shared.sub_status_id;

/** Continue Application: shared with multiple insurers and nothing filled on Docs yet -> resume at Quote */
export const shouldResumeAtQuote = (data: any): boolean => {
    const sharedInsurers = String(data?.share_insurer_ids ?? '').split(',').map((id) => id.trim()).filter(Boolean);
    return sharedInsurers.length > 1 && !hasDocsData(data);
};

/** createAgencyLead payload that stores the unsubmitted Docs values (lead stays 1/1) */
export const buildDocsDraftPayload = ({ requestData = {}, docData = {}, leadId, user = {} }: any) => {
    const payload: any = {
        ...requestData,
        user_id: user?.id,
        role_id: user?.role_id,
        ...docData,
        per_sameas_cur: docData?.per_sameas_cur ? IS_ACC_TOGGLE.INACTIVE : IS_ACC_TOGGLE.ACTIVE,
        lead_type: LEAD_TYPE.AGENT_WEB,
        insurer_branch_id: docData?.insurer_branch_id || requestData?.insurer_branch_id,
        lead_id: leadId,
        // is_shared=1 keeps the lead at Quotation Shared until docs are submitted
        is_shared: QUOTATION_SHARE_TYPE.QUOTATION_SHARE,
        share_insurer_ids: String(requestData?.share_insurer_ids || requestData?.insurer_id || ''),
        customer_discount: Number(requestData?.customer_discount || 0),
        customer_discount_per: Number(requestData?.customer_discount_per || 0),
    };
    ['old_plate_area', 'vehicle', 'version_id', 'sort_by', 'old_insurer_id', 'bm_id'].forEach((key) => delete payload[key]);

    if (requestData?.policy_holder === POLICY_HOLDER.COMPANY) {
        ['ktp_id', 'marital_status', 'gender', 'dob', 'city_birth'].forEach((key) => delete payload[key]);
    }
    if (payload?.insurance_type) {
        const types = Array.isArray(payload.insurance_type) ? payload.insurance_type : [payload.insurance_type];
        payload.multi_year = types.map((item: number) => ({ insurance_type: item }));
        delete payload.insurance_type;
    }
    // half typed values the API rejects
    ['per_postal_code', 'cur_postal_code'].forEach((key) => {
        if (payload[key] && !/^\d{5}$/.test(String(payload[key]))) delete payload[key];
    });
    if (payload?.plate_number && /^[A-Za-z]+$/.test(String(payload.plate_number).trim())) delete payload.plate_number; // only area prefix
    if (payload?.ktp_id && !/^\d+$/.test(String(payload.ktp_id))) delete payload.ktp_id;
    return payload;
};
